function Parallax(){

    this.build();

}

Parallax.prototype.build = function(){

    $('.parallax').each(function(){
        let element = $(this);

        let end = ( element.data('end') ) ? element.data('end') : '-30%';

        gsap.to(element, {
            y: end,
            ease: 'none',
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    $('.footer-bg').each(function(){
        let element = $(this);

        gsap.to(element, {
            y: '-5%',
            ease: 'none',
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                scrub: true
            }
        });
    });

};
